import apiMiddleware from "../../../api/apiMiddleware";

// list languages with pagination and search
export const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `language-master?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data.data;
};

// create language
export const create = async (language) => {
  const response = await apiMiddleware.post("language-master", language);
  return response.data;
};

// get language by id
export const getById = async (id) => {
  const response = await apiMiddleware.get(`language-master/${id}`);
  return response.data;
};

// update language
export const update = async ({ id, ...language }) => {
  const response = await apiMiddleware.put(`language-master/${id}`, {
    name: language.name,
    status: language.status
  });
  return response.data;
};

// delete language
export const deleteLanguage = async (id) => {
  const response = await apiMiddleware.delete(`language-master/${id}`);
  return response.data;
};